/* eslint-disable no-console */
import router from '@/router'
import store from '@/store'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = '织带机监控 - ' + to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/permission.js